export default "__VITE_ASSET__DhQ8I843__"